<template>
  <b-modal
    hide-footer
    v-model="showModal"
    size="md"
    :title="$t('replyModal')"
    centered
  >
    <b-form class="mb-2">
      <div class="mt-2">
        <b-form-group label="Select a Message Tag" v-slot="{ ariaDescribedby }">
          <div v-for="item in messageTagType" :key="item.id">
            <b-form-radio
              v-model="formTag.messageTagType"
              :aria-describedby="ariaDescribedby"
              class="mb-1"
              :name="item.name"
              :value="item.id"
              >{{ item.label }}</b-form-radio
            >
          </div>
        </b-form-group>
      </div>
      <div class="mt-2">
        <InputTextArea
          v-model="formTag.textReply"
          textFloat="Text Reply"
          placeholder="Text Reply"
          isRequired
          id="tagTextReply-1"
          rows="3"
          :v="$v.formTag.textReply"
        />
      </div>
    </b-form>
    <div class="mt-3 d-flex w-100">
      <div class="mx-auto">
        <b-button
          @click="confirm"
          variant="main-primary"
          class="ml-1"
          :disabled="isLoading"
          >{{ $t("comfirm") }}</b-button
        >
      </div>
    </div>
  </b-modal>
</template>

<script>
import InputTextArea from "@/components/inputs/InputTextArea";
import { required } from "vuelidate/lib/validators";
export default {
  props: {
    userChatInfo: {
      type: Object,
      required: false
    },
    crmDetail: {
      type: Object,
      required: false
    },
    chatRoomId: {
      type: [String],
      required: false
    }
  },
  components: {
    InputTextArea
  },
  data() {
    return {
      showModal: false,
      isLoading: false,
      choice: null,

      formTag: {
        messageTagType: 4,
        textReply: ""
      },
      messageTagType: [
        // {
        //   id: 1,
        //   name: "confirmed-event-update",
        //   label: "Confirmed Event Update"
        // },
        // {
        //   id: 2,
        //   name: "post-purchase-update",
        //   label: "Post-Purchase Update"
        // },
        // {
        //   id: 3,
        //   name: "account-update",
        //   label: "Account Update"
        // },
        {
          id: 4,
          name: "human-agent",
          label: "Human Agent"
        }
      ]
    };
  },
  validations() {
    return {
      formTag: {
        messageTagType: { required },
        textReply: { required }
      }
    };
  },
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    async confirm() {
      this.$v.formTag.$touch();
      if (this.$v.formTag.$error) return;
      this.$emit("confirm", this.formTag);
      this.hide();
    }
  }
};
</script>

<style lang="scss" scoped>
.list-reply {
  .text-wrap {
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    color: #598e74;
    display: -webkit-box;
    min-height: 1.2rem;
    line-height: 1.2rem;
    max-height: 2.4rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.list-item-reply:hover {
  background-color: #ebedef;
  cursor: pointer;
}
.reply-key {
  word-wrap: break-word;
}
.badge-badge-private {
  color: #fff;
  background-color: #832abf;
  border: 1px solid #832abf;
}
.badge-badge-public {
  background-color: #fff;
  color: #832abf;
  border: 1px solid #832abf;
  font-size: 10px;
}
.panel-warning {
  text-align: center;
  svg {
    color: #faab32;
    font-size: 90px;
    margin-bottom: 10px;
  }
  p {
    font-size: 16px;
    font-weight: bold;
  }
}
::v-deep .btn-main-primary,
::v-deep .btn-outline-primary {
  min-width: 150px !important;
}
@media (max-width: 767.98px) {
  ::v-deep .btn-main-primary,
  ::v-deep .btn-outline-primary {
    min-width: unset !important;
  }
}
</style>
